import config from '@/config'
import GeomPolygon from 'ol/geom/polygon'
import OLFeature from 'ol/feature'
import FormatGeoJSON from 'ol/format/geojson'
import booleanContains from '@turf/boolean-contains'

const GeoJSONParser = new FormatGeoJSON
const { bbox } = config

const geoserverURL = config.geoserver.geoserverURL;
const ambitoLayerName = `${config.geoserver.geoserverWorkspace}:ambito`
const ambitoLayerURL = `${geoserverURL}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=${ambitoLayerName}&maxFeatures=100000&outputFormat=application%2Fjson`

// Mala práctica
var ambitoFeature = null
fetch(ambitoLayerURL)
  .then(res => res.json())
  .then(featureCollection => GeoJSONParser.readFeatures(featureCollection))
  .then(features => features[0].getGeometry().getCoordinates())
  .then(coordinates => new OLFeature({geometry: new GeomPolygon(coordinates[0])}))
  .then(feature => (ambitoFeature = feature))
  // .then(() => console.log('ambito feature', ambitoFeature))


/**
 * Devuelve true o false dependiendo de si el polígono pasado está dentro
 * del ámbito del municipio.
 * El caso de uso es resaltar el polígono con un rojo de error a la hora
 * de dibujar avisando al usuario que no se permite dibujar un polígono fuera
 * del ámbito
 * @param {*} polyDraw 
 * @param {*} featureProjection 
 */
export default function (polyDraw, featureProjection) {
  let poly1 = ambitoFeature.clone()
  let poly2 = polyDraw.clone()

  poly1.getGeometry().transform(featureProjection, 'EPSG:4326')
  poly2.getGeometry().transform(featureProjection, 'EPSG:4326')

  poly1 = GeoJSONParser.writeFeatureObject(poly1)
  poly2 = GeoJSONParser.writeFeatureObject(poly2)

  return !booleanContains(poly1, poly2)
}


// WEBPACK FOOTER //
// ./src/components/core/utils/out-of-extent.js